/* eslint-disable react/prop-types */
import { Link } from 'react-router-dom';
import Logo from '@assets/logo1.png';
import LogoWhite from '@assets/whitelogo.png';
import { SocialIcon } from 'react-social-icons';
import { useState } from 'react';
import MobileNav from '../MobileNav/MobileNav';
import { RiMenu3Fill } from 'react-icons/ri';
import { motion } from 'framer-motion';
import { Sun, Moon } from 'lucide-react';

/* eslint-disable react/no-unknown-property */
const Navbar = ({ toggleTheme }) => {
   const [isMobileNavOpen, setMobileNavOpen] = useState(false);

   const toggleMobileNav = () => setMobileNavOpen(!isMobileNavOpen);

   const [isDay, setIsDay] = useState(true);
   const scrollToSection = (sectionId) => {
      const element = document.getElementById(sectionId);
      if (element) {
         // Scroll the element into view with smooth behavior
         element.scrollIntoView({
            behavior: 'smooth',
            block: 'start' // Align to the top of the viewport
         });

         // After smooth scroll, immediately adjust for the navbar
         setTimeout(() => {
            const offset = 80; // Adjust this value according to the height of your navbar
            const elementPosition = element.getBoundingClientRect().top;
            const offsetPosition = elementPosition + window.pageYOffset - offset;

            window.scrollTo({
               top: offsetPosition,
               behavior: 'smooth'
            });
         }, 300); // Delay for smooth scroll to complete before adjusting
      }
   };

   return (
      <>
         <nav
            className="bg-white dark:bg-neutral-900 fixed w-full z-20 top-0 start-0 border-b border-gray-200 dark:border-gray-600"
            id="navbar"
         >
            <div className="max-w-screen-xl flex flex-wrap items-center justify-between mx-auto p-4">
               <Link
                  to="/"
                  className="flex items-center space-x-3 rtl:space-x-reverse"
                  onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
               >
                  <img src={isDay ? Logo : LogoWhite} className="h-14 w-full" alt="Flowbite Logo" />
               </Link>
               <div className="flex  rtl:space-x-reverse md:order-2 md:hidden lg:block ">
                  <div className=" sm:flex items-center space-x-2 md:space-x-2">
                     <motion.button
                        onClick={() => {
                           setIsDay(!isDay);
                           toggleTheme();
                        }}
                        className={`absolute -ml-16 mt-2 h-7 w-14 block md:hidden rounded-full p-1 transition-colors duration-500 
   focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-offset-2
   ${isDay ? 'bg-blue-400' : 'bg-indigo-900'}`}
                        role="switch"
                        aria-checked={isDay}
                        aria-label="Toggle day/night mode"
                        whileTap={{ scale: 0.95 }}
                     >
                        <motion.div
                           className="absolute top-1 h-5 w-5 rounded-full bg-white shadow-md flex items-center justify-center"
                           animate={{
                              x: isDay ? 28 : 0,
                              rotate: isDay ? 0 : 360,
                              backgroundColor: isDay ? 'rgb(255, 255, 255)' : 'rgb(254, 243, 199)'
                           }}
                           transition={{
                              type: 'spring',
                              stiffness: 400,
                              damping: 30
                           }}
                        >
                           {isDay ? <Sun className="h-4 w-4 text-amber-500" /> : <Moon className="h-4 w-4 text-indigo-700" />}
                        </motion.div>

                        {/* Background stars - only visible in night mode */}
                        {!isDay && (
                           <motion.div
                              initial={{ opacity: 0 }}
                              animate={{ opacity: 1 }}
                              transition={{ duration: 0.3 }}
                              className="absolute inset-0 overflow-hidden"
                           >
                              <motion.div
                                 className="absolute h-1 w-1 bg-white rounded-full top-1 left-2"
                                 animate={{ scale: [1, 1.2, 1] }}
                                 transition={{ duration: 1.5, repeat: Infinity }}
                              />
                              <motion.div
                                 className="absolute h-1 w-1 bg-white rounded-full top-3 left-3"
                                 animate={{ scale: [1, 1.2, 1] }}
                                 transition={{ duration: 2, repeat: Infinity }}
                              />
                              <motion.div
                                 className="absolute h-1 w-1 bg-white rounded-full top-2 left-4"
                                 animate={{ scale: [1, 1.2, 1] }}
                                 transition={{ duration: 1.8, repeat: Infinity }}
                              />
                           </motion.div>
                        )}
                     </motion.button>
                     <SocialIcon url="https://github.com/Nitesh511" network="github" style={{ height: 40, width: 40 }} />
                     <SocialIcon
                        url="https://www.linkedin.com/in/nitesh-karki-8bba1b203/"
                        target="new"
                        network="linkedin"
                        style={{ height: 40, width: 40, marginRight: '10px' }}
                     />
                  </div>

                  {/* Toggle Button for Mobile/Tablet */}
                  <button
                     data-collapse-toggle="navbar-sticky"
                     type="button"
                     className="inline-flex items-center p-2 w-10 h-10 justify-center text-sm text-gray-500 rounded-lg md:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200 dark:text-gray-400 dark:hover:bg-gray-700 dark:focus:ring-gray-600"
                     aria-controls="navbar-sticky"
                     aria-expanded="false"
                     onClick={toggleMobileNav}
                  >
                     <RiMenu3Fill fontSize={32} color="blue" />
                  </button>
               </div>
               <div className="items-center justify-between hidden w-full md:flex md:w-auto md:order-1" id="navbar-sticky">
                  <ul className="flex flex-col p-4 md:p-0 mt-4 font-medium border border-gray-100 rounded-lg bg-gray-50 md:space-x-8 rtl:space-x-reverse md:flex-row md:mt-0 md:border-0 md:bg-white dark:bg-neutral-900 md:dark:bg-neutral-900 dark:dark:bg-neutral-900">
                     {/* <li>
                        <Link
                           to={'/'}
                           className="block py-2 px-3 text-white bg-blue-700 rounded md:bg-transparent md:text-blue-700 md:p-0 md:dark:text-blue-500"
                           aria-current="page"
                        >
                           HOME
                        </Link>
                     </li> */}
                     <li>
                        <Link
                           href="#"
                           onClick={() => scrollToSection('about')}
                           className="block py-2 px-3 text-gray-900 rounded hover:bg-gray-100 md:hover:bg-transparent md:hover:text-blue-700 md:p-0 md:dark:hover:text-blue-500 dark:text-white dark:hover:bg-gray-700 dark:hover:text-white md:dark:hover:bg-transparent dark:border-gray-700"
                        >
                           ABOUT ME
                        </Link>
                     </li>
                     <li>
                        <Link
                           href="#"
                           onClick={() => scrollToSection('services')}
                           className="block py-2 px-3 text-gray-900 rounded hover:bg-gray-100 md:hover:bg-transparent md:hover:text-blue-700 md:p-0 md:dark:hover:text-blue-500 dark:text-white dark:hover:bg-gray-700 dark:hover:text-white md:dark:hover:bg-transparent dark:border-gray-700"
                        >
                           SERVICES
                        </Link>
                     </li>

                     <li>
                        <Link
                           href="#"
                           onClick={() => scrollToSection('skills')}
                           className="block py-2 px-3 text-gray-900 rounded hover:bg-gray-100 md:hover:bg-transparent md:hover:text-blue-700 md:p-0 md:dark:hover:text-blue-500 dark:text-white dark:hover:bg-gray-700 dark:hover:text-white md:dark:hover:bg-transparent dark:border-gray-700"
                        >
                           SKILLS
                        </Link>
                     </li>
                     <li>
                        <Link
                           href="#"
                           onClick={() => scrollToSection('portfolio')}
                           className="block py-2 px-3 text-gray-900 rounded hover:bg-gray-100 md:hover:bg-transparent md:hover:text-blue-700 md:p-0 md:dark:hover:text-blue-500 dark:text-white dark:hover:bg-gray-700 dark:hover:text-white md:dark:hover:bg-transparent dark:border-gray-700"
                        >
                           PORTFOLIO
                        </Link>
                     </li>
                     {/* <li>
                        <Link
                           href="#"
                           className="block py-2 px-3 text-gray-900 rounded hover:bg-gray-100 md:hover:bg-transparent md:hover:text-blue-700 md:p-0 md:dark:hover:text-blue-500 dark:text-white dark:hover:bg-gray-700 dark:hover:text-white md:dark:hover:bg-transparent dark:border-gray-700"
                        >
                           CLIENTS
                        </Link>
                     </li> */}
                     <li>
                        <Link
                           href="#"
                           onClick={() => scrollToSection('contact')}
                           className="block py-2 px-3 text-gray-900 rounded hover:bg-gray-100 md:hover:bg-transparent md:hover:text-blue-700 md:p-0 md:dark:hover:text-blue-500 dark:text-white dark:hover:bg-gray-700 dark:hover:text-white md:dark:hover:bg-transparent dark:border-gray-700"
                        >
                           CONTACT
                        </Link>
                     </li>
                     <motion.button
                        onClick={() => {
                           setIsDay(!isDay);
                           toggleTheme();
                        }}
                        className={`relative h-7 w-14 rounded-full p-1 transition-colors duration-500 
   focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-offset-2
   ${isDay ? 'bg-blue-400' : 'bg-indigo-900'}`}
                        role="switch"
                        aria-checked={isDay}
                        aria-label="Toggle day/night mode"
                        whileTap={{ scale: 0.95 }}
                     >
                        <motion.div
                           className="absolute top-1 h-5 w-5 rounded-full bg-white shadow-md flex items-center justify-center"
                           animate={{
                              x: isDay ? 28 : 0,
                              rotate: isDay ? 0 : 360,
                              backgroundColor: isDay ? 'rgb(255, 255, 255)' : 'rgb(254, 243, 199)'
                           }}
                           transition={{
                              type: 'spring',
                              stiffness: 400,
                              damping: 30
                           }}
                        >
                           {isDay ? <Sun className="h-4 w-4 text-amber-500" /> : <Moon className="h-4 w-4 text-indigo-700" />}
                        </motion.div>

                        {/* Background stars - only visible in night mode */}
                        {!isDay && (
                           <motion.div
                              initial={{ opacity: 0 }}
                              animate={{ opacity: 1 }}
                              transition={{ duration: 0.3 }}
                              className="absolute inset-0 overflow-hidden"
                           >
                              <motion.div
                                 className="absolute h-1 w-1 bg-white rounded-full top-1 left-2"
                                 animate={{ scale: [1, 1.2, 1] }}
                                 transition={{ duration: 1.5, repeat: Infinity }}
                              />
                              <motion.div
                                 className="absolute h-1 w-1 bg-white rounded-full top-3 left-3"
                                 animate={{ scale: [1, 1.2, 1] }}
                                 transition={{ duration: 2, repeat: Infinity }}
                              />
                              <motion.div
                                 className="absolute h-1 w-1 bg-white rounded-full top-2 left-4"
                                 animate={{ scale: [1, 1.2, 1] }}
                                 transition={{ duration: 1.8, repeat: Infinity }}
                              />
                           </motion.div>
                        )}
                     </motion.button>
                  </ul>
               </div>
            </div>
         </nav>
         <MobileNav isOpen={isMobileNavOpen} onClose={toggleMobileNav} />
      </>
   );
};

export default Navbar;
